import buildFullPath from 'axios/lib/core/buildFullPath.js'
import buildURL from 'axios/lib/helpers/buildURL.js'

function withProtocol (url, protocol) {
  return url.startsWith('//') ? `${protocol}${url}` : url
}

export function shouldSignWalletRequest (requestInfo, unsignedPaths) {
  return requestInfo.isWalletApi && !unsignedPaths.has(requestInfo.path)
}

export function resolveRequestInfo (config, options = {}) {
  const location = options.location || window.location
  const walletBaseUrl = options.walletBaseUrl || process.env.VUE_APP_BASE_URL
  const fullPath = buildFullPath(config.baseURL, config.url)
  const requestUrl = buildURL(fullPath, config.params, config.paramsSerializer)
  const parsedUrl = new URL(withProtocol(requestUrl, location.protocol), location.href)
  const walletUrl = new URL(withProtocol(walletBaseUrl, location.protocol), location.href)
  return {
    endpointUrl: parsedUrl.pathname,
    isWalletApi: parsedUrl.origin === walletUrl.origin,
    path: parsedUrl.pathname,
    queryString: parsedUrl.search.slice(1)
  }
}
